var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigAddQuantity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 0.833008C4.93992 0.833008 0.833252 4.93967 0.833252 9.99967C0.833252 15.0597 4.93992 19.1663 9.99992 19.1663C15.0599 19.1663 19.1666 15.0597 19.1666 9.99967C19.1666 4.93967 15.0599 0.833008 9.99992 0.833008ZM10.9166 6.33301C10.9166 5.82675 10.5062 5.41634 9.99992 5.41634C9.49366 5.41634 9.08325 5.82675 9.08325 6.33301V9.08301H6.33325C5.82699 9.08301 5.41658 9.49341 5.41658 9.99967C5.41658 10.5059 5.82699 10.9163 6.33325 10.9163H9.08325V13.6663C9.08325 14.1726 9.49366 14.583 9.99992 14.583C10.5062 14.583 10.9166 14.1726 10.9166 13.6663V10.9163H13.6666C14.1728 10.9163 14.5833 10.5059 14.5833 9.99967C14.5833 9.49341 14.1728 9.08301 13.6666 9.08301H10.9166V6.33301ZM2.66659 9.99967C2.66659 14.0422 5.95742 17.333 9.99992 17.333C14.0424 17.333 17.3333 14.0422 17.3333 9.99967C17.3333 5.95717 14.0424 2.66634 9.99992 2.66634C5.95742 2.66634 2.66659 5.95717 2.66659 9.99967Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigAddQuantity);
export default __webpack_public_path__ + "static/media/jobconfig-add-quantity.8428eff720eba3944fff8bc7fd164c47.svg";
export { ForwardRef as ReactComponent };